import React, { Component } from 'react';
import { connect } from "react-redux";
import InfiniteScroll from 'react-infinite-scroller';
import Loading from "../Loading";
import ArchiveLi from "./ArchiveLi";
import Search from "./Search";
import ArchiveDetail from "./ArchiveDetail";
import {useParams} from "react-router-dom";
import { parseUrl } from 'query-string';
import Filter from "../filter/Filter";
import API from "../../lib/api"

@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class Archives extends Component {

    constructor(props) {

        super(props);
        this.state= {
            archivesChat: [],
            currentChat: [],
            active:false,
            limit:15,
            page:1,
            hasMoreItems:true,
            loadingMore:false,
            scrollTopVisible:false,
            order:true, // newest
        }
        this.getMoreChats = this.getMoreChats.bind(this);
        this.getArchiveChat = this.getArchiveChat.bind(this);
        this.scrollTop = this.scrollTop.bind(this);
        this.hhh = this.hhh.bind(this);
        this.changeOrder = this.changeOrder.bind(this);
        this.searchFilter=this.searchFilter.bind(this);


    }
    searchFilter(){

        this.setState({
            archivesChat:[],
            loadingMore:true,
            page:1
        });
        this.getArchiveChat({
            page:1,
            order:this.state.order
        }).then((resolve,reject)=>{
            this.setState({
                loadingMore:false
            })
            resolve=resolve.archiveChats;
            if(resolve.length>0){
                var activeChatsCopy = {};
                Object.keys(resolve).forEach(key => {
                    activeChatsCopy[key] = resolve[key];
                });

                var dataArr = this.state.archivesChat;
                for (var values in activeChatsCopy) {
                    dataArr.push(activeChatsCopy[values]);
                }

                this.setState({
                    "archivesChat":dataArr,
                    "hasMoreItems":true,
                    "page":this.state.page+1
                });
            }
            else{
                this.setState({
                    "hasMoreItems" :false
                });
            }
        });

    }

    changeOrder(){
        this.setState({
            order:!this.state.order,
            archivesChat:[],
            loadingMore:true,
            page:1
        });
        this.getArchiveChat({
            page:1,
            order:!this.state.order
        }).then((resolve,reject)=>{
            this.setState({
                loadingMore:false
            })

            resolve=resolve.archiveChats;
            if(resolve.length>0){

                var activeChatsCopy = {};
                Object.keys(resolve).forEach(key => {
                    activeChatsCopy[key] = resolve[key];
                });

                var dataArr = this.state.archivesChat;
                for (var values in activeChatsCopy) {
                    dataArr.push(activeChatsCopy[values]);
                }

                this.setState({
                    "archivesChat":dataArr,
                    "hasMoreItems":true,
                    "page":this.state.page+1
                });

            } else{
                this.setState({
                    "hasMoreItems" :false
                });
            }


        });
    }
    hhh(){

           if(document.getElementById("chatsidebar").scrollTop>700){

                this.setState({
                    scrollTopVisible:true
                })
           } else{
               this.setState({
                   scrollTopVisible:false
               })
           }

    }
    scrollTop(){
        document.getElementById("chatsidebar").scroll(0,0);
    }
      async getArchiveChat(data){
          var _that=this;
            return new Promise((resolve,reject)=>{
                const defaultHeaders = {
                    'content-type' : 'application/x-www-form-urlencoded',
                }

                var queryFilter=parseUrl(window.location.href);

                var formData = new FormData();
                formData.append("limit", _that.state.limit);
                formData.append("page", data.page);
                formData.append("order", data.order);
                formData.append("filter", JSON.stringify(queryFilter));


                if(typeof this.props.match.params.id!=="undefined"){
                    formData.append("id", this.props.match.params.id);
                }

                API.post("getArchiveChat",formData).then((response) => {
                    if(response.status===200) {
                        if (typeof response.data !== "undefined") {

                            if(typeof response.data.currentChats!=="undefined"){
                                if(response.data.currentChats.length>0){
                                    var $currentChatCopy = {};
                                    Object.keys(response.data.currentChats).forEach(key => {
                                        $currentChatCopy[key] = response.data.currentChats[key];
                                    });
                                    var currentChatArr = [];
                                    for (var values in $currentChatCopy) {
                                        currentChatArr.push($currentChatCopy[values]);
                                    }

                                    this.setState({
                                        "currentChat":currentChatArr
                                    })
                                }
                            }

                            resolve(response.data);

                        }
                    }
                });


            });
      }
       async getMoreChats(page){

        if(!this.state.hasMoreItems || this.state.loadingMore) {
            return;
        }
        this.setState({
            loadingMore:true
        });

         await this.getArchiveChat({
             page:this.state.page,
             order:this.state.order
         }).then((resolve,reject)=>{
              this.setState({
                  loadingMore:false
              })

             resolve=resolve.archiveChats;
              if(resolve.length>0){

                  var activeChatsCopy = {};
                  Object.keys(resolve).forEach(key => {
                      activeChatsCopy[key] = resolve[key];
                  });

                  var dataArr = this.state.archivesChat;
                  for (var values in activeChatsCopy) {
                      dataArr.push(activeChatsCopy[values]);
                  }


                  this.setState({
                      "archivesChat":dataArr,
                      "hasMoreItems":true,
                      "page":this.state.page+1
                  })
              }else{
                  this.setState({
                      "hasMoreItems" :false
                  })
              }
          });
      }


    componentDidMount() {

        this.props.dispatch({
            type: 'SET_MENU',
            data: "archive"
        });

       this.getArchiveChat({
           page:this.state.page,
           order:this.state.order
       }).then((resolve,reject)=>{



           resolve=resolve.archiveChats;
           if(resolve.length>0){
               var activeChatsCopy = {};
               Object.keys(resolve).forEach(key => {
                   activeChatsCopy[key] = resolve[key];
               });
               var archiveDataArr = [];
               for (var values in activeChatsCopy) {
                   archiveDataArr.push(activeChatsCopy[values]);
               }


               this.setState({
                   "archivesChat":archiveDataArr,
                   "active":true,
                   "page":this.state.page+1,
                   "hasMoreItems":true
               })
           }else{
               this.setState({
                   "archivesChat":[],
                   "active":true,
                   "hasMoreItems" :false
               })
           }

       })

    }


    render() {

        const { t } = this.props;

            if(this.state.active===true) {

                return (
                    <React.Fragment>

                        <div id="chat_left_sidebar_id">
                            <div className="sidebar-group left-sidebar chat_sidebar">
                                <div id="chats" className="left-sidebar-wrap sidebar active">

                                    <div className="sidebar-header">
                                        <div className="sidebar-header-flex">
                                            <div className="sidebar-header-title">
                                                Archives
                                            </div>
                                        </div>
                                    </div>
                                    <div className="sidebar-filter">
                                        <Search searchFilter={this.searchFilter.bind(this)}/>

                                            <Filter filtering={this.searchFilter.bind(this)} filterItems={[
                                                "Date",
                                                "Agent",
                                                "Department",
                                                "Assignment",
                                                "Rating",
                                            ]}/>

                                        <div className="sidebar-filter-order-container">
                                            <div className="sidebar-chat-count"></div>
                                            <div className="sidebar-order-container">
                                                <span className="sidebar-order" onClick={this.changeOrder.bind(this)}>
                                                    {this.state.order===true &&
                                                    <span>Newest First&nbsp;<i className='bx bx-chevron-up'></i></span>
                                                    }
                                                    {this.state.order===false &&
                                                    <span>Oldest First&nbsp;<i className='bx bx-chevron-down'></i></span>
                                                    }
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="sidebar-body" id="chatsidebar"  onScroll={this.hhh.bind(this)} style={{"overflowY":"scroll","height":"100%"}}>
                                        <InfiniteScroll
                                            pageStart={this.state.page}
                                            initialLoad={false}
                                            loadMore={this.getMoreChats.bind(this)}
                                            hasMore={this.state.hasMoreItems}
                                            useWindow={false}
                                            threshold={10}
                                        >
                                            <ul className="user-list chat-list" >

                                                {Object.keys(this.state.archivesChat).sort((a, b) => a.user_closed > b.user_closed ? -1:1).map(chat => {
                                                    return <ArchiveLi  selected_id={this.props.match.params.id} data={this.state.archivesChat[chat]} />
                                                })}
                                            </ul>
                                            {Object.keys(this.state.archivesChat).length < 1 &&
                                            <div className="archive-not-found-item">
                                                <img src={`/Public/images/not-found.jpg`}/>
                                                <div className="title">No Records Found</div>
                                                <p className="description">
                                                    Check your filter combination or
                                                   clear your search and try again
                                                </p>
                                            </div>
                                            }
                                            {this.state.loadingMore === true &&
                                            <div className="loading-more-chats">Loading ...</div>
                                            }
                                            {this.state.scrollTopVisible===true &&
                                            <button type="button" onClick={this.scrollTop.bind(this)}
                                                    className="scroll-top-button">
                                                <div>
                                                    <i className="bx bx-up-arrow-alt"></i>
                                                </div>
                                            </button>
                                            }

                                        </InfiniteScroll>
                                    </div>
                                </div>
                            </div>


                        </div>
                        <div className="chat-center-div">
                            <ArchiveDetail cdata={this.state.currentChat} data={this.state.archivesChat} id={this.props.match.params.id} />
                        </div>

                    </React.Fragment>
                );
            } else{
                return (
                    <Loading />
                )
            }

    }
}
export function withRouter(Children){
    return(props)=>{

        const match  = {params: useParams()};
        return <Children {...props}  match = {match}/>
    }
}
export default withRouter(Archives, { withRef: true });
